import { render } from "./modal-plan-purchase.vue?vue&type=template&id=1153ec3e"
import script from "./modal-plan-purchase.vue?vue&type=script&lang=js"
export * from "./modal-plan-purchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__